import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-tai-chi': {
			// /chair-tai-chi-m?safe&exp=web_male_chair_tai_chi_military~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_male_chair_tai_chi_military'
					),
			},
			funnel: {
				id: 'ob-male-tai-chi-chair-workouts-military',
				locale: ['en'],
			},
		},
	},
]

export default config
